import React from "react";
import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import { useUrlQuery } from "hooks/useUrlQuery";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import { persistAuthSession } from "utils/persistAuthSession";

const useLogin = () => {
	const query = useUrlQuery();
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const login = async (obj) => {
		const instance = await InitApi({ accessToken });
		const body = deleteEmptyObjects(obj);
		const response = await instance.post("/auth/login", body);
		return response;
	};

	return useMutation(login, {
		onSuccess: async ({ data: body }) => {
			persistAuthSession(body, {
				queryClient,
				history,
				intended: query?.get("intended"),
			});
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

		},
	});
};

export default useLogin;
